import React from "react";
import PropTypes from "prop-types";
import { Icon } from "antd";

/**
 * "Play recording" pill + on-demand audio element for the verification call.
 * The audio node is only mounted once the user opts in.
 */
class CallPlayer extends React.Component {
    state = { playing: false };

    toggle = () => this.setState(prev => ({ playing: !prev.playing }));

    render() {
        const { recordingUrl } = this.props;
        const hasRecording = Boolean(recordingUrl);
        const { playing } = this.state;
        return (
            <div className={"cc-player"}>
                <button
                    type={"button"}
                    className={"cc-player__btn"}
                    onClick={hasRecording ? this.toggle : undefined}
                    disabled={!hasRecording}
                >
                    <Icon type={playing ? "pause-circle" : "play-circle"} theme={"filled"} />
                    <span>{playing ? "Hide recording" : "Play recording"}</span>
                </button>
                {playing && hasRecording ? (
                    <audio
                        className={"cc-player__audio"}
                        src={recordingUrl}
                        controls
                        autoPlay
                    >
                        Your browser does not support audio playback.
                    </audio>
                ) : null}
            </div>
        );
    }
}

CallPlayer.propTypes = {
    recordingUrl: PropTypes.string
};

export default CallPlayer;
